import {config} from "@/constants/config";
import {httpRequest} from "@/providers/http";
import type {TransferPayload} from "./transfer.schema";

export interface TransferApiPayload {
  amount: number;
  receiver_id: string;
}

export interface TransferResponse {
  data?: {
    status?: string;
    message?: string;
    reference?: string;
  };
  [key: string]: unknown;
}

export const sendMoneyService = async (payload: TransferPayload): Promise<TransferResponse> => {
  return httpRequest<TransferResponse, TransferApiPayload>({
    method: "POST",
    url: "/user/send-money",
    baseUrl: config.walletApiUrl,
    body: {
      amount: payload.amount,
      receiver_id: payload.receiver_id,
    },
  });
};
